import axios from '@/axios'
import * as types from '../../mutation-types'

export default {
    namespaced: true,

    state: {
        recompenses: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/salaries/recompense').then(({ data }) => {
                commit(types.STORE_RECOMPENSES, data);
                return data;
            })
        },

        create({ commit }, { name, pattern, isRate, value, method }) {
            return axios.post('/salaries/recompense', { name, pattern, isRate, value, method });
        },

        update({ commit }, { id, name, pattern, isRate, value, method }) {
            return axios.put(`/salaries/recompense/${id}`, { name, pattern, isRate, value, method });
        },
    },

    mutations: {
        [types.STORE_RECOMPENSES](state, recompenses) {
            state.recompenses = recompenses;
        }
    },

    getters: {
        getRecompenseById: state => id => state.recompenses.find(c => c.id === id)
    }
}